/* global Promise */
/* eslint-disable max-len */
import angular from 'angular';
import * as R from 'ramda';
import moment from 'moment';

export default function EditProductDialogController(
  $q,
  $scope,
  $rootScope,
  ssDialogService,
  alerts,
  loaderService,
  orgDataService,
  reportsDataService,
  vmSharedModelService,
  vmDataService,
  editContactDialog,
  editSOCCommentDialog,
  editInsuranceCommentDialog,
  editProductDialog,
  confirmDialog,
  confirmBeginRiskAssessmentDialog,
) {
  const vm = this;

  vm.newProduct = R.clone(vm.product);

  vm.attachmentIds = [];

  vm.handleCloseDialog = _handleCloseDialog;

  vm.handleEditProductFormSubmit = _handleEditProductFormSubmit;

  vm.handleEditContact = _handleEditContact;
  vm.handleDeleteContact = _handleDeleteContact;

  vm.handleEditSOCComment = _handleEditSOCComment;
  vm.handleDeleteSOCComment = _handleDeleteSOCComment;

  vm.handleEditInsuranceComment = _handleEditInsuranceComment;
  vm.handleDeleteInsuranceComment = _handleDeleteInsuranceComment;

  vm.handleChangeControlReviewFrequency = handleChangeControlReviewFrequency;
  vm.handleChangeRiskAssessmentFrequency = handleChangeRiskAssessmentFrequency;
  vm.handleAttachCallBack = handleAttachCallback;
  vm.handleDetachDocumentCallback = handleDetachDocumentCallback;
  vm.handleDownloadDocument = handleDownloadDocument;
  vm.handleDocumentManagementOpenCallBack = _handleDocumentManagementOpenCallBack;
  vm.removeBiennial = false;

  _activate();

  // ////////////// Methods ///////////////////////

  function _activate() {
    // We need to provide some basic product model to the view until data loads
    getAttachIds();

    loaderService.showViewLoader = true;
    $q.all([
      vmSharedModelService.getUnusedMasterProducts(
        vm.masterVendorId,
        vm.product.vendorId,
        vm.product.masterProductId,
      ),
      vmSharedModelService.getSettings(true),
    ]).then((results) => {
      loaderService.showViewLoader = false;
      vm.unusedMasterProducts = results[0];
      const settings = results[1];
      _populateViewModel(settings);
    });

    if (vm.newProduct.productId > 0
        && (vm.newProduct.masterProductId === null || vm.newProduct.masterProductId === undefined)) {
      vm.newProduct.masterProductId = -1;
    }

    _removeBiennial();
  }

  function _removeBiennial() {
    let isScoreValid = true;
    if(vm.product.lastAssessmentDate){
       vm.product.riskAssessments.forEach(assessment => {
        if(assessment.isActive){
          assessment.riskAssessmentQuestions.forEach(category => {
            if((category.riskCategoryId==1 && category.riskCategoryScore > 0) ||
                (category.riskCategoryId==2 && category.riskCategoryScore > 0) ||
                (category.riskCategoryId==3 && category.riskCategoryScore > 0) ||
                (category.riskCategoryId==5 && category.riskCategoryScore > 0))
            {
              isScoreValid =false;  
            }
          })
        }
      })        
    }
    if(!isScoreValid){
      vm.removeBiennial = true;
    }
  }


  /** ********************************************************
   * Event Handlers
   */

  function _handleEditProductFormSubmit($event) {
    if (_isValid()) {
      _saveProduct().then(() => {
        if (vm.saveType === 'addContact') {
          _setFormUnsubmitted();
          _showAddContactDialog($event);
        } else if (vm.saveType === 'addSOCComment') {
          _setFormUnsubmitted();
          _showAddSOCCommentDialog($event);
        } else if (vm.saveType === 'addInsuranceComment') {
          _setFormUnsubmitted();
          _showAddInsuranceCommentDialog($event);
        } else if (vm.saveType === 'addAnother') {
          _closeDialog().then(() => {
            _showEditProductDialog($event, {
              masterVendorId: vm.masterVendorId,
              product: {
                vendorId: vm.product.vendorId,
                productId: -1,
              },
              vendor: vm.vendor,
              addCallback: vm.addCallback,
            });
          });
        } else if (vm.saveType === 'assess') {
          _closeDialog().then(() => {
            _showConfirmBeginRiskAssessmentDialog($event, {
              vendor: vm.vendor,
              product: vm.product,
            });
          });
        } else if (vm.saveType === 'addAttachment') {
          // do nothing
        } else {
          _closeDialog();
        }
      });
    }
  }
  /*
  function getDocument(documents, documentId) {
    for (let i = 0; i < documents.length; i += 1) {
      if (documents[i].documentId === documentId) {
        return documents[i];
      }
    }
    return null;
  }
  */
  function getAttachIds() {
    vm.attachmentIds = [];
    angular.forEach(vm.newProduct.productDocuments, (productDocument) => {
      vm.attachmentIds.push(productDocument.documentId);
    });
  }

  function handleAttachCallback(documentIds, documents) {
    if (!R.isNil(documentIds)) {
      // attachProductDocuments
      loaderService.showViewLoader = true;
      vmDataService.attachProductDocuments(vm.product.productId, documentIds)
        .then((documentResponse) => {
          vm.newProduct.productDocuments = documentResponse.data;
          vm.newProduct.submittedDocuments = documents;
          getAttachIds();
          loaderService.showViewLoader = false;
          alerts.success('The documents are attached successfully.');
        });
    }
  }

  function handleDetachDocumentCallback($event, document) {
    ssDialogService.dialogs.vendorManagement.confirmDetachDocumentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Detach Document?',
        message: `Are you sure you want to detach the document "${document.name}"?`,
        handleYesClick: () => _handleDetachDocumentYesCallback(document.productDocumentId),
        handleNoClick: _handleDetachDocumentNoCallback,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDetachDocumentDialog);
  }

  function _handleDetachDocumentNoCallback() {
    ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDetachDocumentDialog);
  }

  function _handleDetachDocumentYesCallback(productDocumentId) {
    if (!R.isNil(productDocumentId)) {
      loaderService.showViewLoader = true;
      vmDataService.detachProductDocument(productDocumentId).then(() => {
        vm.newProduct.productDocuments = vm.newProduct.productDocuments.filter(item => item.productDocumentId !== productDocumentId);
        loaderService.showViewLoader = false;
        getAttachIds();
        alerts.success('The document was detached successfully.');
        _handleDetachDocumentNoCallback();
      });
    }
  }

  function handleDownloadDocument(documentId) {
    alerts.info('Please wait. Download is in progress..');
    orgDataService.downloadDocument(documentId).then((downloadDocumentResponse) => {
      reportsDataService.download(downloadDocumentResponse);
    });
  }

  // Product Contacts

  function _showAddContactDialog($event) {
    _showEditContactDialog($event, {
      contact: {
        vendorId: vm.product.vendorId,
        productId: vm.product.productId,
        contactId: -1,
      },
      addCallback: _handleAddContactCallback,
    });
  }

  function _handleAddContactCallback(contact) {
    vm.product.contacts = vm.product.contacts || [];
    vm.product.contacts.push(contact);
    vm.product.hasContact = true;
    vm.newProduct.hasContact = true;
    if (vm.newProduct.contacts === undefined) {
      vm.newProduct.contacts = [];
    }
    if (vm.product.contacts.length > 1) {
      vm.product.contacts = R.sortBy(R.prop('Name'), vm.product.contacts);
    }
    angular.extend(vm.newProduct.contacts, vm.product.contacts);
  }

  function _handleEditContact($event, contact) {
    _showEditContactDialog($event, {
      contact,
      editCallback: _handleEditContactCallback,
    });
  }

  function _showEditContactDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editContactDialog = ssDialogService.alert(
      editContactDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editContactDialog);
  }

  function _handleEditContactCallback(contact) {
    vm.product.contacts = vm.product.contacts || [];

    vm.product.contacts.forEach((existingContact, index) => {
      if (existingContact.contactId === contact.contactId) {
        vm.product.contacts.splice(index, 1, contact);
      }
    });

    vm.product.hasContact = true;
    vm.newProduct.hasContact = true;
    if (vm.newProduct.contacts === undefined) {
      vm.newProduct.contacts = [];
    }
    if (vm.product.contacts.length > 1) {
      vm.product.contacts = R.sortBy(R.prop('Name'), vm.product.contacts);
    }
    angular.extend(vm.newProduct.contacts, vm.product.contacts);
  }

  function _handleDeleteContact($event, contact) {
    const name = contact.name || contact.Name; // normalize API

    ssDialogService.dialogs.vendorManagement.confirmDeleteContactDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Contact?',
        message: `Are you sure you want to delete the contact "${name}"?`,
        handleYesClick: () => _handleConfirmDeleteContact(contact),
        handleNoClick: _closeDeleteContactDialog,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteContactDialog);
  }

  function _handleConfirmDeleteContact(contact) {
    const contactId = contact.contactId || contact.ContactID;

    loaderService.showViewLoader = true;
    return vmDataService.deleteContact(contactId)
      .then(() => {
        loaderService.showViewLoader = false;
        vm.product.contacts.splice(vm.product.contacts.indexOf(contact), 1);
        vm.product.hasContact = vm.product.contacts.length > 0;
        vm.newProduct.hasContact = vm.product.hasContact;
        vm.newProduct.contacts = [];

        if (vm.newProduct.contacts === null) {
          vm.newProduct.contacts = [];
        }
        angular.extend(vm.newProduct.contacts, vm.product.contacts);
        // alerts.success(`The Contact "${contact.name}" was successfully deleted.`);
        ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteContactDialog);
      });
  }

  function _closeDeleteContactDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteContactDialog);
  }

  // Product SOC Comments

  function _showAddSOCCommentDialog($event) {
    _showEditSOCCommentDialog($event, {
      productSocComment: {
        vendorId: vm.product.vendorId,
        productId: vm.product.productId,
        productSocCommentId: -1,
      },
      addCallback: _handleAddSOCCommentCallback,
    });
  }

  function _showEditSOCCommentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editSOCCommentDialog = ssDialogService.alert(
      editSOCCommentDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editSOCCommentDialog);
  }

  function _handleAddSOCCommentCallback(productSOCComment) {
    vm.product.productSOCComments = vm.product.productSOCComments || [];
    vm.product.productSOCComments.push(productSOCComment);
    vm.product.hasSOCComment = true;
    vm.newProduct.hasSOCComment = true;
    if (vm.newProduct.productSOCComments === undefined) {
      vm.newProduct.productSOCComments = [];
    }
    if (vm.product.productSOCComments.length > 1) {
      vm.product.productSOCComments = R.sortBy(R.prop('-createdDate'), vm.product.productSOCComments);
    }
    angular.extend(vm.newProduct.productSOCComments, vm.product.productSOCComments);
  }

  function _handleEditSOCComment($event, productSocComment) {
    _showEditSOCCommentDialog($event, {
      productSocComment,
      editCallback: _handleEditSOCCommentCallback,
    });
  }

  function _handleEditSOCCommentCallback(productSOCComment) {
    vm.product.productSOCComments = vm.product.productSOCComments || [];

    vm.product.productSOCComments.forEach((existingProductSocComment, index) => {
      if (existingProductSocComment.productSocCommentId === productSOCComment.productSocCommentId) {
        vm.product.productSOCComments.splice(index, 1, productSOCComment);
      }
    });

    vm.product.hasSOCComment = true;
    vm.newProduct.hasSOCComment = true;
    if (vm.newProduct.productSOCComments === undefined) {
      vm.newProduct.productSOCComments = [];
    }
    if (vm.product.productSOCComments.length > 1) {
      vm.product.productSOCComments = R.sortBy(R.prop('-createdDate'), vm.product.productSOCComments);
    }
    angular.extend(vm.newProduct.productSOCComments, vm.product.productSOCComments);
  }

  function _handleDeleteSOCComment($event, productSOCComment) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteSOCCommentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete SOC Note?',
        message: 'Are you sure you want to delete the Note"?',
        handleYesClick: () => _handleConfirmDeleteSOCComment(productSOCComment),
        handleNoClick: _closeDeleteSOCCommentDialog,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteSOCCommentDialog);
  }

  function _closeDeleteSOCCommentDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteSOCCommentDialog);
  }

  function _handleConfirmDeleteSOCComment(productSOCComment) {
    const productSOCCommentId = productSOCComment.productSocCommentId || productSOCComment.productSOCCommentId;

    loaderService.showViewLoader = true;
    return vmDataService.deleteSOCComment(productSOCCommentId).then(() => {
      loaderService.showViewLoader = false;
      let index = 0;
      let counter = 0;

      R.forEach((comment) => {
          if (comment.productSocCommentId && productSOCCommentId) {
            index = counter;
          } else {
            counter += 1;
          }
        }, vm.product.productSOCComments);

      vm.product.productSOCComments.splice(index, 1);
      vm.product.hasSOCComment = vm.product.productSOCComments.length > 0;
      vm.newProduct.hasSOCComment = vm.product.hasSOCComment;
      vm.newProduct.productSOCComments = [];

      if (vm.newProduct.productSOCComments === null) {
        vm.newProduct.productSOCComments = [];
      }
      angular.extend(vm.newProduct.productSOCComments, vm.product.productSOCComments);
      alerts.success('The Note was successfully deleted.');
      _closeDeleteSOCCommentDialog();
    });
  }// Product Insurance Comments

  function _showAddInsuranceCommentDialog($event) {
    _showEditInsuranceCommentDialog($event, {
      productInsuranceComment: {
        vendorId: vm.product.vendorId,
        productId: vm.product.productId,
        productInsuranceCommentId: -1,
      },
      addCallback: _handleAddInsuranceCommentCallback,
    });
  }

  function _showEditInsuranceCommentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editInsuranceCommentDialog = ssDialogService.alert(
      editInsuranceCommentDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editInsuranceCommentDialog);
  }

  function _handleAddInsuranceCommentCallback(productInsuranceComment) {
    vm.product.productInsuranceComments = vm.product.productInsuranceComments || [];
    vm.product.productInsuranceComments.push(productInsuranceComment);
    vm.product.hasInsuranceComment = true;
    vm.newProduct.hasInsuranceComment = true;
    if (vm.newProduct.productInsuranceComments === undefined) {
      vm.newProduct.productInsuranceComments = [];
    }
    if (vm.product.productInsuranceComments.length > 1) {
      vm.product.productInsuranceComments = R.sortBy(R.prop('-createdDate'), vm.product.productInsuranceComments);
    }
    angular.extend(vm.newProduct.productInsuranceComments, vm.product.productInsuranceComments);
  }

  function _handleEditInsuranceComment($event, productInsuranceComment) {
    _showEditInsuranceCommentDialog($event, {
      productInsuranceComment,
      editCallback: _handleEditInsuranceCommentCallback,
    });
  }

  function _handleEditInsuranceCommentCallback(productInsuranceComment) {
    vm.product.productInsuranceComments = vm.product.productInsuranceComments || [];

    vm.product.productInsuranceComments.forEach((existingProductInsuranceComment, index) => {
      if (existingProductInsuranceComment.productInsuranceCommentId === productInsuranceComment.productInsuranceCommentId) {
        vm.product.productInsuranceComments.splice(index, 1, productInsuranceComment);
      }
    });

    vm.product.hasInsuranceComment = true;
    vm.newProduct.hasInsuranceComment = true;
    if (vm.newProduct.productInsuranceComments === undefined) {
      vm.newProduct.productInsuranceComments = [];
    }
    if (vm.product.productInsuranceComments.length > 1) {
      vm.product.productInsuranceComments = R.sortBy(R.prop('-createdDate'), vm.product.productInsuranceComments);
    }
    angular.extend(vm.newProduct.productInsuranceComments, vm.product.productInsuranceComments);
  }

  function _handleDeleteInsuranceComment($event, productInsuranceComment) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteInsuranceCommentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Insurance Note?',
        message: 'Are you sure you want to delete the Note"?',
        handleYesClick: () => _handleConfirmDeleteInsuranceComment(productInsuranceComment),
        handleNoClick: _closeDeleteInsuranceCommentDialog,
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteInsuranceCommentDialog);
  }

  function _closeDeleteInsuranceCommentDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteInsuranceCommentDialog);
  }

  function _handleConfirmDeleteInsuranceComment(productInsuranceComment) {
    const productInsuranceCommentId = productInsuranceComment.productInsuranceCommentId || productInsuranceComment.productInsuranceCommentId;

    loaderService.showViewLoader = true;
    return vmDataService.deleteInsuranceComment(productInsuranceCommentId).then(() => {
      loaderService.showViewLoader = false;
      let index = 0;
      let counter = 0;

      R.forEach((comment) => {
        if (comment.productInsuranceCommentId && productInsuranceCommentId) {
          index = counter;
        } else {
          counter += 1;
        }
      }, vm.product.productInsuranceComments);

      vm.product.productInsuranceComments.splice(index, 1);
      vm.product.hasInsuranceComment = vm.product.productInsuranceComments.length > 0;
      vm.newProduct.hasInsuranceComment = vm.product.hasInsuranceComment;
      vm.newProduct.productInsuranceComments = [];

      if (vm.newProduct.productInsuranceComments === null) {
        vm.newProduct.productInsuranceComments = [];
      }
      angular.extend(vm.newProduct.productInsuranceComments, vm.product.productInsuranceComments);
      alerts.success('The Note was successfully deleted.');
      _closeDeleteInsuranceCommentDialog();
    });
  }

  // Alerting

  function handleChangeControlReviewFrequency() {
    vm.newProduct.controlReviewFrequency = _getFrequency(vm.newProduct.controlsReviewFrequencyValue);
  }

  function handleChangeRiskAssessmentFrequency() {
    vm.newProduct.riskAssessmentFrequency = _getFrequency(vm.newProduct.riskAssessmentFrequencyValue);
  }

  function _handleCloseDialog() {
    return _closeDialog();
  }

  function _handleDocumentManagementOpenCallBack($event) {
    if (vm.newProduct.productId > 0) {
      return true;
    }
    vm.saveType = 'addAttachment';
    $scope.editProductForm.$submitted = true;
    if (_isValid()) {
      _handleEditProductFormSubmit($event);
      return true;
    }
    return false;
  }
  /** ********************************************************
   * Private Functions
   */

  function _setFormUnsubmitted() {
    $scope.editProductForm.$setPristine();
    $scope.editProductForm.$setUntouched();
  }

  function _showEditProductDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editProductDialog = ssDialogService.alert(
      editProductDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editProductDialog);
  }

  function _showConfirmBeginRiskAssessmentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.confirmBeginRiskAssessmentDialog = ssDialogService.alert(
      confirmBeginRiskAssessmentDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmBeginRiskAssessmentDialog);
  }

  function _saveProduct() {
    vm.newProduct.lastAssessmentDate = vm.newProduct.fullLastAssessmentDate && vm.newProduct.fullLastAssessmentDate.toJSON();
    vm.newProduct.lastReviewDate = vm.newProduct.fullLastReviewDate && vm.newProduct.fullLastReviewDate.toJSON();

    vm.newProduct.contractStart = vm.newProduct.contractStartDate && vm.newProduct.contractStartDate.toJSON();
    vm.newProduct.contractEnd = vm.newProduct.contractEndDate && vm.newProduct.contractEndDate.toJSON();

    if (vm.newProduct.socPeriodStartDateMoment !== undefined) {
      vm.newProduct.socPeriodStartDate = moment(vm.newProduct.socPeriodStartDateMoment).format('MM/DD/YYYY');
    }

    if (vm.newProduct.socPeriodEndDateMoment !== undefined) {
      vm.newProduct.socPeriodEndDate = moment(vm.newProduct.socPeriodEndDateMoment).format('MM/DD/YYYY');
    } else {
      vm.newProduct.socPeriodStartDate = null;
      vm.newProduct.socPeriodEndDate = null;
    }

    if (vm.newProduct.insuranceEffectiveDateMoment !== undefined) {
      vm.newProduct.insuranceEffectiveDate = moment(vm.newProduct.insuranceEffectiveDateMoment).format('MM/DD/YYYY');
    }

    if (vm.newProduct.insuranceExpirationDateMoment !== undefined) {
      vm.newProduct.insuranceExpirationDate = moment(vm.newProduct.insuranceExpirationDateMoment).format('MM/DD/YYYY');
    } else {
      vm.newProduct.insuranceEffectiveDate = null;
      vm.newProduct.insuranceExpirationDate = null;
    }

    const isNew = vm.newProduct.productId < 0;

    if (!isNew && angular.equals(vm.product, vm.newProduct)) {
      // No need to save
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return vmDataService.saveProduct(vm.newProduct)
      .then((response) => {
        loaderService.showViewLoader = false;
        const savedProduct = response.data;

        angular.extend(vm.newProduct, savedProduct);
        angular.extend(vm.product, vm.newProduct);
        if (isNew) {
          vm.addCallback(vm.product);
        }
        $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.product.vendorId });
        $rootScope.$broadcast('refreshNotifications');
        vmSharedModelService.resetProductCache(savedProduct.vendorId);
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editProductDialog);
  }

  function _populateViewModel(settings) {
    vm.agreementType = vm.product.isSubscription ? '2' : '1';
    _setDates();
    vm.hasBeenAssessed = !R.isNil(vm.product.hasRiskAssessments);
    vm.hasBeenReviewed = !R.isNil(vm.product.completedRiskControls);
    _applySettings(settings);
    vm.newProduct.riskAssessmentFrequencyAlertThresholdTime = vm.product.riskAssessmentFrequencyAlertThresholdTime
      || '1';
    vm.newProduct.controlsReviewFrequencyAlertThresholdTime = vm.product.controlsReviewFrequencyAlertThresholdTime
      || '1';
    vm.newProduct.controlsReviewFrequencyValue = _getFrequencyValue(vm.newProduct.controlReviewFrequency);
    vm.newProduct.riskAssessmentFrequencyValue = _getFrequencyValue(vm.newProduct.riskAssessmentFrequency);
  }

  function _applySettings(settings) {
    vm.riskAssessmentAlertEnabled = settings.riskAssessmentAlertEnabled;
    vm.controlsReviewAlertEnabled = settings.controlReviewAlertEnabled;

    if ((vm.product.controlReviewFrequency === null) || (vm.product.controlReviewFrequency === undefined)) {
      vm.newProduct.controlReviewFrequency = settings.controlReviewFrequency;
      vm.newProduct.controlsReviewFrequencyAlertThresholdValue = settings.controlReviewFrequencyAlertThresholdValue;
      vm.newProduct.controlsReviewFrequencyAlertThresholdTime = settings.controlReviewFrequencyAlertThresholdTime;
    }

    if ((vm.product.riskAssessmentFrequency === null) || (vm.product.riskAssessmentFrequency === undefined)) {
      vm.newProduct.riskAssessmentFrequency = settings.riskAssessmentFrequency;
      vm.newProduct.riskAssessmentFrequencyAlertThresholdValue = settings.riskAssessmentFrequencyAlertThresholdValue;
      vm.newProduct.riskAssessmentFrequencyAlertThresholdTime = settings.riskAssessmentFrequencyAlertThresholdTime;
    }

    if ((vm.product.contractAutoRenewalAlertThresholdTime === null)
        || (vm.product.contractAutoRenewalAlertThresholdTime === undefined)) {
      vm.newProduct.contractAutoRenewalAlertThresholdTime = settings.contractAutoRenewalAlertThresholdTime;
      vm.newProduct.contractAutoRenewalAlertThresholdValue = settings.contractAutoRenewalAlertThresholdValue;
    }

    if ((vm.product.contractExpirationAlertThresholdTime === null)
        || (vm.product.contractExpirationAlertThresholdTime === undefined)) {
      vm.newProduct.contractExpirationAlertThresholdTime = settings.contractExpirationAlertThresholdTime;
      vm.newProduct.contractExpirationAlertThresholdValue = settings.contractExpirationAlertThresholdValue;
    }
  }

  function _getFrequencyValue(frequency) {
    switch (frequency) {
      case 'quarterly':
        return 0;
      case 'semiannually':
        return 1;
      case 'annually':
        return 2;
      case 'biennially':
        return 3;
      default:
        return 0;
    }
  }

  function _getFrequency(value) {
    switch (value) {
      case 0:
        return 'quarterly';
      case 1:
        return 'semiannually';
      case 2:
        return 'annually';
      case 3:
        return 'biennially';
      default:
        return 'quarterly';
    }
  }

  function _setDates() {
    vm.today = moment().startOf('day');
    vm.yesterday = vm.today.subtract(1, 'day');
    vm.tomorrow = vm.today.add(1, 'day');
    vm.newProduct.contractStartDate = !R.isNil(vm.product.contractStart)
      ? moment(vm.product.contractStart)
      : null;
    vm.newProduct.contractEndDate = !R.isNil(vm.product.contractEnd)
      ? moment(vm.product.contractEnd)
      : null;
    vm.newProduct.fullLastAssessmentDate = !R.isNil(vm.product.lastAssessmentDate)
      ? moment(vm.product.lastAssessmentDate)
      : null;
    vm.newProduct.fullLastReviewDate = !R.isNil(vm.product.lastReviewDate)
      ? moment(vm.product.lastReviewDate)
      : null;
    vm.newProduct.socPeriodStartDateMoment = !R.isNil(vm.product.socPeriodStartDate)
      ? moment(vm.product.socPeriodStartDate)
      : null;
    vm.newProduct.socPeriodEndDateMoment = !R.isNil(vm.product.socPeriodEndDate)
      ? moment(vm.product.socPeriodEndDate)
      : null;
    vm.newProduct.insuranceEffectiveDateMoment = !R.isNil(vm.product.insuranceEffectiveDate)
      ? moment(vm.product.insuranceEffectiveDate)
      : null;
    vm.newProduct.insuranceExpirationDateMoment = !R.isNil(vm.product.insuranceExpirationDate)
      ? moment(vm.product.insuranceExpirationDate)
      : null;
  }

  function _isValid() {
    let isValid = true;

    if ($scope.editProductForm !== 'undefined') {
      if ($scope.editProductForm.$valid !== 'undefined') {
        isValid = $scope.editProductForm.$valid;
      }
    }

    return isValid;
  }
}

EditProductDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'ssDialogService',
  'alerts',
  'loaderService',
  'orgDataService',
  'reportsDataService',
  'vmSharedModelService',
  'vmDataService',
  'editContactDialog',
  'editSOCCommentDialog',
  'editInsuranceCommentDialog',
  'editProductDialog',
  'confirmDialog',
  'confirmBeginRiskAssessmentDialog',
];
